import { Component, type ErrorInfo, type ReactNode } from 'react';

import { GoRow } from '@/components/GoRow';
import { Notice } from '@/components/Notice';
import { reportError } from '@/sentry';
import { NOTICE_W } from '@/components/layout';
import { useT } from '@/str';

function CrashNotice() {
  const t = useT();
  const offline = typeof navigator !== 'undefined' && !navigator.onLine;
  return (
    <Notice sign="!" title={t.errTitle} body={offline ? t.errNetwork : t.errGeneric}>
      <GoRow className={NOTICE_W} onClick={() => window.location.reload()}>
        {t.reloadApp}
      </GoRow>
    </Notice>
  );
}

export class ErrorBoundary extends Component<
  { children: ReactNode; className?: string },
  { failed: boolean }
> {
  state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Render error:', error, info.componentStack);
    reportError(error, { componentStack: info.componentStack });
  }

  render(): ReactNode {
    if (!this.state.failed) return this.props.children;
    return this.props.className ? (
      <div className={this.props.className}>
        <CrashNotice />
      </div>
    ) : (
      <CrashNotice />
    );
  }
}
